import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import NextArrow from "./../../CommonUI/NextArrow/NextArrow";
import PrevArrow from "./../../CommonUI/PrevArrow/PrevArrow";
import Slider from "react-slick";
import IOSImg from "./../../../Images/IOS.png";
import Android from "./../../../Images/Android.png";
import Webapp from "./../../../Images/Webapp.png";
import ScreenerImg from "./../../../Images/Screener-img.png";
import PlayStore from "./../../../Images/playstore.png";
import AppStore from "./../../../Images/appstore.png";
import "./PlatformNew.css";
function PlatformNew() {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay: true,
    // speed: 2000,
    // autoplaySpeed: 2000,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const TradeDownload=()=>{
    window.open("https://download.moneysukh.com:6633/Downloads/Softwares/Moneysukh_Desk_setup.zip",'_blank')
  }
  return (
    <>
      <section className="plaform-new" id="platform_section">
        <Container className="add-border">
        <div className="homeplatforms_section">
          <Row>
            <Col md={12}>
              <h1>
                <span>Platforms</span>
              </h1>
              <h5>
              Platforms Powered with dynamic alert, 
                <br />
                real time feeds and a very handy dashboard
              </h5>
              <Slider {...settings}>
                <div className="each-platform ios">
                  <h3>Mobile Platforms</h3>
                  <p className="heigh-less">
                  Stable & Powerful platform 
                  </p>
                  <ul className="platform-list">
                    <li>
                      <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN">
                        <img src={PlayStore} alt="PlayStore" />
                      </a>
                    </li>
                    <li>
                      <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241">
                        <img src={AppStore} alt="AppStore" />
                      </a>
                    </li>
                  </ul>
                  <span>
                    <img className="img-fluid" src={IOSImg} alt="IOSImg" />
                  </span>
                </div>
                {/* <div className="each-platform android">
                  <h3>Android App</h3>
                  <p>
                    State of the art application, powered with dynamic alert
                    tools, real time price alerts and a very handy dashboard
                  </p>
                  <span>
                    <img className="img-fluid" src={Android} alt="Android" />
                  </span>
                </div> */}
                <div className="each-platform webapp">
                
                <h3>Web</h3>
                <p className="heigh-less">
                    Platform with advanced market sentiment tracker, fast
                    price updation.
                  </p>
                  <div className="parent_btn">
                      <a href="https://online.moneysukh.com/" className="startnow_btn">Get Started</a>
                  </div>
                  <span>
                    <img className="img-fluid" src={Webapp} alt="Webapp" />
                  </span>
                  
                </div>
                <div className="each-platform screener">
              
                  <h3>Exe</h3>
                  <p className="heigh-less">Rich and Feature loaded Trading Platform  for Traders.</p>
                  <div className="parent_btn">
                      <a  href="https://moneysukh.com:8443/res/download" className="startnow_btn" >Download Now</a>
                  </div>
                  <span>
                    <img className="img-fluid" src={ScreenerImg} alt="IOSImg" />
                  </span>
                  
                </div>
              </Slider>
            </Col>
          </Row>
          </div>
        </Container>
      </section>
    </>
  );
}
export default PlatformNew;
